import React from 'react'

const SvgStampFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M8 6.364c0 1.494.313 2.25.653 3.07.075.182.152.368.227.566h6.24c.075-.198.152-.384.228-.566.34-.82.652-1.576.652-3.07C16 2.654 12.889 2 12 2c-.889 0-4 .655-4 4.364zM9.474 13c-.02-.368-.052-.7-.092-1h5.236c-.04.3-.072.632-.092 1H20a2 2 0 012 2v4H2v-4a2 2 0 012-2h5.474zM20 20.5a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 014 20.5V20h16v.5z' />
  </svg>
)

export default SvgStampFilled
